import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { normalizePercentage } from 'src/app/modules/snapshot/custom-snapshot-chart-modules/chart-value.util';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import HighchartsMore from 'highcharts/highcharts-more';
import { LollipopService } from '../../lollipop.service';
import Stock from 'highcharts/modules/stock';
import { Observable } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute } from '@angular/router';
Stock(Highcharts);

import {
  COMMON_CONSTANTS,
  COMMON_CONSTANTS_Percentage,
  COMMON_CONSTANTS_SNAPSHOT,
} from 'src/app/common/constants/common-constants';

Stock(Highcharts);
import { Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
HighchartsMore(Highcharts);

function roundChangeText(changeText: any): any {
  return changeText == null || changeText === 'NA'
    ? changeText
    : Math.round(Number(changeText));
}

@Component({
  selector: 'app-lollipopchart01-custom',
  template: `
    <div
      [id]="'chart-container' + id"
      [ngStyle]="{ height: popUp ? '28em' : height }"
    ></div>
  `,
})
export class Lollipopchart01ComponentCustom {
  chart: any;
  event: any;
  lollipopChartData: any;
  properties: any;
  data: any;
  max: any;
  min: any;
  public seriesData1: any[] = [];
  public seriesDataForTop10: any[] = [];
  jsonData: any;
  chartCategories: any[] = [];
  categoryImages: any[] = [];
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  changeValueSeries: any;
  significance: any;
  maxBarValue = 0;
  sampleSize: any;
  defaultCategories1: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = '#ff0000';
  maxDataPoints: any = 8;
  maxSeries: any;
  userselectedchartdata: any;
  //parameters from snapshot-chrtparent
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = '24em';
  @Input() isOutput: any;
  selectedMetric: any = '';

  constructor(
    private http: HttpClient,
    private LollipopService: LollipopService,
    private _customSnapshotService: CustomsnapshotService,
    private route: ActivatedRoute,
    private _configService: SnapshotService,
    private barService: BarserviceService,
  ) {}
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = '';
  significanceValue: any = 'None';
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties: any;
  private widgetIsBrandDependent: boolean | null | undefined;

  private isBrandIndependentChart(): boolean {
    if (this.widgetIsBrandDependent === false) {
      return true;
    }

    const props = this.configuredProperties ?? this.properties ?? {};
    return props?.bdBiToggle === false || props?.bdBiToggle === 'false';
  }

  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(
        this.customData.customizationProperties,
      );
      this.widgetIsBrandDependent = this.customData?.isBrandDependent;
      const metricFromData = this.customData?.selectedMetric || '';
      this.customData = this.customData.metric[0];
      if (this.configuredProperties?.sort == 'default')
        this.customData.metric_value.sort(
          (a: any, b: any) => a.selectorder - b.selectorder,
        );
      this.selectedMetric =
        this._customSnapshotService.getSelectedMetricSync(this.id) ||
        metricFromData;
      if (this.selectedMetric) {
        this.LollipopService.selectedMetric = this.selectedMetric;
      }
      // this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value) => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }),
      );
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value) => {
          this.significanceValue = value;
          this.updateSig();
        }),
      );
      this.subscriptions.add(
        this._customSnapshotService
          .getSelectedMetric(this.id)
          .subscribe((selectedMetric) => {
            if (selectedMetric) {
              this.selectedMetric = selectedMetric;
              this.LollipopService.selectedMetric = this.selectedMetric;
              this.updateSig();
            }
          }),
      );
    } else {
      this.http
        .get<any>('assets/Data/lollipopdata.json')
        .subscribe((data: any) => {
          this.jsonData = data;
          this.data = data[0];
          this.lollipopChartData = data[0]['data'];
          this.properties = data[0]['properties'][0];
          this.properties.decimalRoundOff = 2;
          this.properties.showLegend = true;
          this.properties.legendPosition = 'bottom';
          this.route.paramMap.subscribe((params) => {
            const userData = history.state.userData;
            this.userselectedchartdata = userData; // Use the userData object as needed
            if (this.userselectedchartdata?.widgetEditSelection) {
              if (
                this.userselectedchartdata?.widgetEditSelection
                  ?.customizationProperties != ''
              ) {
                this.properties = JSON.parse(
                  this.userselectedchartdata?.widgetEditSelection
                    ?.customizationProperties,
                );
              }
            }
          });
          this.getData(
            this.jsonData,
            this.properties.datalabelStyle == 'lowSample',
          );
          this.getChart(
            'chart-container' + this.id,
            this.seriesData1,
            this.seriesDataForTop10,
            this.properties,
          );
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(
          this.customData.customizationProperties,
        );
        this.widgetIsBrandDependent = this.customData?.isBrandDependent;
        this.customData = this.customData.metric[0];
        if (this.configuredProperties?.sort == 'default')
          this.customData.metric_value.sort(
            (a: any, b: any) => a.selectorder - b.selectorder,
          );
        this.updateSig();
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http
      .get<any>('assets/Data/barData.json')
      .subscribe((data: any) => {
        this.jsonData = data;
        //this.data = data[0];
        this.barChartData = data[0]['data'];
        this.properties = data[0]['properties'][0];
        this.properties =
          this.configuredProperties != undefined
            ? this.configuredProperties
            : this.properties;
        this.properties.datalabelStyle =
          this.significanceValue == 'None' ? 'default' : 'sigChange';
        this.properties.datalabelStyle = this._configService.isIndexSelected
          ? 'index'
          : this.properties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel ==
          COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel ==
                COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel ==
                  COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel ==
          COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel ==
                COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel ==
                  COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.preparemainChartData(
          this.customData,
          this.selectedMetric || this.LollipopService.selectedMetric,
        );
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getData(this.jsonData, this.properties.datalabelStyle == 'ls');

        let docEle = document.getElementById('chart-container' + this.id);
        if (docEle != null) {
          docEle.innerHTML = '';
        }

        this.getChart(
          'chart-container' + this.id,
          this.seriesData1,
          this.seriesDataForTop10,
          this.properties,
        );
      });
  }

  chartMainData: any = [];

  private isBrandDependentMode(properties: any): boolean {
    const raw =
      properties?.branddependent ??
      properties?.BrandDependent ??
      properties?.bdBiToggle;

    if (raw === undefined || raw === null || raw === '') {
      return true;
    }

    if (typeof raw === 'string') {
      const normalized = raw.trim().toLowerCase();
      return normalized === 'true' || normalized === 'enable';
    }

    return !!raw;
  }

  private isBrandMetricToggleMetric(properties: any): boolean {
    if (!this.isBrandDependentMode(properties)) {
      return false;
    }

    return (
      (properties?.BrandMetricToggle || 'Brand').toString().trim().toLowerCase() ===
      'metric'
    );
  }

  private getLastSegmentOrValue(value: any): string {
    const rawValue = (value ?? '').toString();
    const splitData = rawValue.split('|');

    return splitData.length > 1
      ? (splitData[splitData.length - 1] || '').trim()
      : rawValue;
  }

  preparemainChartData(data: any, metricFilter: string = '') {
    let i = 0;
    this.chartMainData = [];
    const isMetricView = this.isBrandMetricToggleMetric(this.properties);
    const isMultipleBrands =
      this._configService.selectedcompareacrossOption?.includes('Multiple Brands');
    const isBrandIndependent = this.isBrandIndependentChart();
    const filteredMetricValueCandidate =
      isMultipleBrands && metricFilter && !isMetricView && !isBrandIndependent
        ? data.metric_value.filter((lev2: any) => lev2.option === metricFilter)
        : data.metric_value;
    const filteredMetricValue =
      filteredMetricValueCandidate && filteredMetricValueCandidate.length > 0
        ? filteredMetricValueCandidate
        : data.metric_value;
    const result = this.transformRowChild(filteredMetricValue);
    result.forEach((lev2: any) => {
      let chartDataPoints = lev2.data;

      if (isMultipleBrands && metricFilter && isMetricView) {
        chartDataPoints = chartDataPoints.filter((dataArr: any) => {
          const colChildLast = (dataArr.colChild || '')
            .toString()
            .split('|')
            .pop()
            ?.trim();
          const rowChildVal = (dataArr.rowChild || '').toString().trim();
          const selectedVal = metricFilter.toString().trim();
          return colChildLast === selectedVal || rowChildVal === selectedVal;
        });
      }

      if (isMultipleBrands && isBrandIndependent && chartDataPoints?.length > 1) {
        chartDataPoints = [chartDataPoints[0]];
      }

      chartDataPoints.forEach((dataArr: any) => {
        const categoryName = this.getLastSegmentOrValue(dataArr.colChild);
        const rowChildName = isMetricView
          ? this.getLastSegmentOrValue(dataArr.rowChild)
          : dataArr.rowChild;
        let d1 = {
          'Series Name': this._configService.multiCohort
            ? lev2.option
            : rowChildName || lev2.metric_group,
          'Category Name':
            isMultipleBrands && isBrandIndependent
              ? lev2.option
              : this._configService.selectedSnapshotType
                    .toLowerCase()
                    .includes('audience snapshot')
                ? dataArr.rowChild
                : this._configService.selectedSnapshotType
                      .toLowerCase()
                      .includes('multi') || this._configService.multiCohort
                  ? categoryName
                  : lev2.option,
          'Rounded Value':
            dataArr.data == null
              ? null
              : dataArr.CalculationType?.toLowerCase() == 'share' ||
                  dataArr.CalculationType?.toLowerCase() == 'respgrp'
                ? normalizePercentage(dataArr.data)
                : dataArr.CalculationType?.toLowerCase() == 'index' &&
                    dataArr.data == 'NA'
                  ? 'NA'
                  : dataArr.data,
          Value:
            dataArr.CalculationType?.toLowerCase() == 'share' ||
            dataArr.CalculationType?.toLowerCase() == 'respgrp'
              ? normalizePercentage(dataArr.data)
              : dataArr.CalculationType?.toLowerCase() == 'index' &&
                  dataArr.data == 'NA'
                ? 'NA'
                : dataArr.data,
          ValueForIndex:
            dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
            dataArr.data2 == 'NA'
              ? 'NA'
              : dataArr.data2,
          ActualIndexValue:
            dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
            dataArr.data2 == null
              ? null
              : dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
                  dataArr.data2 == 'NA'
                ? 'NA'
                : dataArr.data2,
          Label:
            dataArr.data == null
              ? 'NA'
              : dataArr.CalculationType?.toLowerCase() == 'share' ||
                  dataArr.CalculationType?.toLowerCase() == 'respgrp'
                ? normalizePercentage(dataArr.data)
                : dataArr.CalculationType?.toLowerCase() == 'index' &&
                    dataArr.data == 'NA'
                  ? 'NA'
                  : dataArr.data,
          'Change value vs PY': dataArr.changeVsPY,
          Significance: '-1',
          'Sample size': dataArr.baseValueforLSorIs,
          Significance2: '1',
          XValue: ++i,
          isPercentage:
            dataArr.CalculationType?.toLowerCase() == 'share' ||
            dataArr.CalculationType?.toLowerCase() == 'respgrp'
              ? true
              : false,
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dataArr.Significance_Value,
          color: dataArr.color,
          colorLinearGradient: dataArr.colorLinearGradient,
        };
        this.chartMainData.push(d1);
        if (!isNaN(d1['Rounded Value'])) {
          const rounded = Math.round(parseFloat(d1['Rounded Value']) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if (this.configuredProperties) {
      if (this.configuredProperties?.sort == 'ascending') {
        const sortedData = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in ascending order
          if (a['Value'] === 'NA' && b['Value'] === 'NA') {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a['Value'] === 'NA') {
            return 1; // If a is "NA", place it after b
          }
          if (b['Value'] === 'NA') {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a['Value'] - b['Value'];
        });
        this.chartMainData = sortedData;
      }
      if (this.configuredProperties?.sort == 'descending') {
        const sortedDataDesc = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in descending order
          if (a['Value'] === 'NA' && b['Value'] === 'NA') {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a['Value'] === 'NA') {
            return -1; // If a is "NA", place it after b
          }
          if (b['Value'] === 'NA') {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b['Value'] - a['Value']; // For descending order, reverse the comparison
        });
        this.chartMainData = sortedDataDesc;
      }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4,
      },
    };
  }

  getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;

      chartData[0].data = this.chartMainData
        .filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null)
        .map((item: any, idx: number) => ({ ...item, XValue: idx + 1 }));

      if (chartData[0].data.length == 0) {
        this.seriesData1 = [];
        return;
      }

      //get the category images
      this.categoryImages = chartData[0].data.map(
        (item: { [x: string]: string }) => item['Category Image'],
      );
      this.categoryImages = [''].concat(this.categoryImages);
      //use full dataset (do not filter to a single series)
      const indiaData = chartData[0].data;

      //calculate the min and max value for the y-axis
      maxValue = Math.max(
        ...indiaData.map(
          (item: { [x: string]: string }) => parseFloat(item['Value']) || 0,
        ),
      );
      minValue = Math.min(
        ...indiaData.map(
          (item: { [x: string]: string }) => parseFloat(item['Value']) || 0,
        ),
      );
      this.max =
        maxValue +
        Math.ceil(
          maxValue * (this._configService.isRespondentLevel ? 0.1 : 0.4),
        );
      this.min =
        minValue -
        Math.ceil(
          minValue * (this._configService.isRespondentLevel ? 0.1 : 0.2),
        );

      //loop throught he filtered data
      let isTop10 = this.properties.top10 ? true : false;
      let count = 0;
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({
        //extract rounded value,if null plot as 0
        value:
          item['Value'] == null
            ? 0
            : this._configService.userRole != 'superadmin' &&
                Number(item['Sample size']) <= this._configService.ISthreshold
              ? 0
              : parseFloat(item['Value']).toFixed(
                  this.properties.decimalRoundOff,
                ),
        //if lowsample is selected,if rounded value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1
          ? value
          : parseFloat(item['Sample size']) > this.barService.sampleSizeConstant
            ? value
            : 0,
        //name for each datapoint
        name: item['Category Name'],

        //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern
          ? this.getPatternForImage(this.barService.patternImages[i++])
          : this.properties.gradientBarColor
            ? item['colorLinearGradient']
            : item['color'],

        //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],

        visible: true,
        legend: false,
        zIndex: 2,
        type: 'column',
        dataLabels: {
          borderWidth: 0,
        },
        data: [
          {
            name: item['Category Name'],
            seriesName: item['Series Name'],
            ispercent: item['isPercentage'],
            y:
              this._configService.userRole != 'superadmin' &&
              Number(item['Sample size']) <= this._configService.ISthreshold
                ? 0
                : !lowSample1
                  ? item['Value'] == null
                    ? 0
                    : Number(
                        parseFloat(item['Value']).toFixed(
                          this.properties.decimalRoundOff,
                        ),
                      )
                  : parseFloat(item['Sample size']) >
                      this.barService.sampleSizeConstant
                    ? item['Value'] == null
                      ? 0
                      : Number(
                          parseFloat(item['Value']).toFixed(
                            this.properties.decimalRoundOff,
                          ),
                        )
                    : 0,
            //x value is used just to assign different colors for each bar
            x: parseInt(item['XValue']),
            indexValue:
              this._configService.userRole != 'superadmin' &&
              Number(item['Sample size']) <= this._configService.ISthreshold
                ? 0
                : !lowSample1
                  ? item['ValueForIndex'] == null
                    ? 0
                    : Number(
                        parseFloat(item['ValueForIndex']).toFixed(
                          this.properties.decimalRoundOff,
                        ),
                      )
                  : parseFloat(item['Sample size']) >
                      this.barService.sampleSizeConstant
                    ? item['ValueForIndex'] == null
                      ? 0
                      : Number(
                          parseFloat(item['ValueForIndex']).toFixed(
                            this.properties.decimalRoundOff,
                          ),
                        )
                    : 0,
            actualIndexValue: item['ActualIndexValue'],
          },
        ],

        //extract changeVs value
        changeValueSeries: indiaData.map(
          (item: { [x: string]: string }) => item['Change value vs PY'],
        ),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) =>
          parseFloat(item['Significance']),
        ),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) =>
          parseFloat(item['Significance2']),
        ),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) =>
          parseFloat(item['Sample size']),
        ),
        //extract rounded value
        roundedValue: indiaData.map(
          (item: { [x: string]: string }) => item['Rounded Value'],
        ),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],
        isPercentage: item['isPercentage'],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: item['Significance_Value'],
      }));

      if (this.seriesData1.filter((x: any) => x.value == 0).length > 0)
        this.min = 0;

      //extract category names
      this.categories = Array.from(
        new Set(
          indiaData.map(
            (item: { [x: string]: string }) => item['Category Name'],
          ),
        ),
      );
      this.categories = [''].concat(
        Array.from(
          new Set(
            indiaData.map(
              (item: { [x: string]: string }) => item['Category Name'],
            ),
          ),
        ),
      );

      //include additional series for marker
      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;
        let offsetMultiplier = 0.03;
        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (
          parseFloat(item['Rounded Value']) < 0 &&
          markerStyle === 'triangle'
        ) {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        if (
          parseFloat(item['Rounded Value']) < 50 &&
          parseFloat(item['Rounded Value']) > 0
        ) {
          offsetMultiplier = 0.1; // Further increase offset if value is less than 50
        }
        if (
          parseFloat(item['Rounded Value']) <= 80 &&
          parseFloat(item['Rounded Value']) >= 50 &&
          parseFloat(item['Rounded Value']) > 0
        ) {
          offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
        }

        const isLowSampleMarker =
          this._configService.userRole != 'superadmin' &&
          Number(item['Sample size']) <= this._configService.ISthreshold;
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 1,
          marker: {
            symbol: this.properties.markerStyle,
            // fillColor: 'red',
            // lineColor: 'red',
            // lineWidth: 2,
            fillColor: isLowSampleMarker
              ? 'rgba(0,0,0,0)'
              : this.properties.showPattern
                ? this.getPatternForImage(this.barService.patternImages[i++])
                : this.properties.gradientBarColor
                  ? item['colorLinearGradient']
                  : item['color'],
            //fillColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i]) : this.properties.gradientBarColor ? this.barService.linearGradients[i] : this.barService.color1[i],
            lineColor: isLowSampleMarker
              ? 'rgba(0,0,0,0)'
              : this.properties.showPattern
                ? this.getPatternForImage(this.barService.patternImages[i++])
                : this.properties.gradientBarColor
                  ? item['colorLinearGradient']
                  : item['color'],
            // lineColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
            radius: 9,
            lineWidth: 0,
          },
          enableMouseTracking: false,
          showInLegend: false,
          visible: true,
          data: [
            {
              name: item['Category Name'],
              y: !lowSample1
                ? item['Rounded Value'] == null ||
                  parseFloat(item['Rounded Value']) === 0
                  ? null
                  : parseFloat(item['Rounded Value']) > 0
                    ? parseFloat(item['Rounded Value'])
                    : parseFloat(item['Rounded Value']) +
                      0.04 * parseFloat(item['Rounded Value'])
                : parseFloat(item['Sample size']) >
                      this.barService.sampleSizeConstant &&
                    item['Rounded Value'] != null &&
                    parseFloat(item['Rounded Value']) !== 0
                  ? parseFloat(item['Rounded Value']) > 0
                    ? parseFloat(item['Rounded Value'])
                    : parseFloat(item['Rounded Value']) +
                      0.05 * parseFloat(item['Rounded Value'])
                  : null,
              x: index + 1,
              z:
                parseFloat(item['Sample Size']) >
                this.barService.sampleSizeConstant
                  ? 0
                  : item['Rounded Value'] != null
                    ? parseFloat(item['Rounded Value'])
                    : 0,
              Sig_LowerLimt: this.Sig_LowerLimt,
              Sig_UpperLimt: this.Sig_UpperLimt,
              Significance_Value: item['Significance_Value'],
            },
          ],
        });
      });

      //Top 10 data
      i = 0;
      this.seriesDataForTop10 = indiaData.map(
        (item: { [x: string]: string }) => ({
          //extract rounded value,if null plot as 0
          value:
            item['Value'] == null
              ? 0
              : this._configService.userRole != 'superadmin' &&
                  Number(item['Sample size']) <= this._configService.ISthreshold
                ? 0
                : parseFloat(item['Value']).toFixed(
                    this.properties.decimalRoundOff,
                  ),
          //if lowsample is selected,if rounded value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
          numericValue: !lowSample1
            ? value
            : parseFloat(item['Sample size']) >
                this.barService.sampleSizeConstant
              ? value
              : 0,
          //name for each datapoint
          name: item['Category Name'],

          //apply pattern/gradient bar color or default color based on selection
          color: this.properties.showPattern
            ? this.getPatternForImage(this.barService.patternImages[i++])
            : this.properties.gradientBarColor
              ? item['colorLinearGradient']
              : item['color'],
          //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],

          visible: true,
          legend: false,
          zIndex: 2,
          type: 'column',
          dataLabels: {
            borderWidth: 0,
          },
          data: [
            {
              name: item['Category Name'],
              seriesName: item['Series Name'],
              ispercent: item['isPercentage'],
              y:
                this._configService.userRole != 'superadmin' &&
                Number(item['Sample size']) <= this._configService.ISthreshold
                  ? 0
                  : !lowSample1
                    ? item['Value'] == null
                      ? 0
                      : Number(
                          parseFloat(item['Value']).toFixed(
                            this.properties.decimalRoundOff,
                          ),
                        )
                    : parseFloat(item['Sample size']) >
                        this.barService.sampleSizeConstant
                      ? item['Value'] == null
                        ? 0
                        : Number(
                            parseFloat(item['Value']).toFixed(
                              this.properties.decimalRoundOff,
                            ),
                          )
                      : 0,
              //x value is used just to assign different colors for each bar
              x: parseInt(item['XValue']),
              indexValue:
                this._configService.userRole != 'superadmin' &&
                Number(item['Sample size']) <= this._configService.ISthreshold
                  ? 0
                  : !lowSample1
                    ? item['ValueForIndex'] == null
                      ? 0
                      : Number(
                          parseFloat(item['ValueForIndex']).toFixed(
                            this.properties.decimalRoundOff,
                          ),
                        )
                    : parseFloat(item['Sample size']) >
                        this.barService.sampleSizeConstant
                      ? item['ValueForIndex'] == null
                        ? 0
                        : Number(
                            parseFloat(item['ValueForIndex']).toFixed(
                              this.properties.decimalRoundOff,
                            ),
                          )
                      : 0,
              actualIndexValue: item['ActualIndexValue'],
            },
          ],

          //extract changeVs value
          changeValueSeries: indiaData.map(
            (item: { [x: string]: string }) => item['Change value vs PY'],
          ),
          //extract significance value
          significance: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Significance']),
          ),
          //extract significance2 value
          significance2: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Significance2']),
          ),
          //extract sample size value
          sampleSize: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Sample size']),
          ),
          //extract rounded value
          roundedValue: indiaData.map(
            (item: { [x: string]: string }) => item['Rounded Value'],
          ),
          //include tooltip to reflect the datalabel property selected
          tooltip: [],
          isPercentage: item['isPercentage'],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: item['Significance_Value'],
        }),
      );

      this.seriesDataForTop10 = this.seriesDataForTop10.slice(0, 10);
      //include additional series for marker
      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;
        let offsetMultiplier = 0.03;
        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (
          parseFloat(item['Rounded Value']) < 0 &&
          markerStyle === 'triangle'
        ) {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        if (
          parseFloat(item['Rounded Value']) < 50 &&
          parseFloat(item['Rounded Value']) > 0
        ) {
          offsetMultiplier = 0.1; // Further increase offset if value is less than 50
        }
        if (
          parseFloat(item['Rounded Value']) <= 80 &&
          parseFloat(item['Rounded Value']) >= 50 &&
          parseFloat(item['Rounded Value']) > 0
        ) {
          offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
        }

        if (i < 10) {
          const isLowSampleMarkerTop10 =
            this._configService.userRole != 'superadmin' &&
            Number(item['Sample size']) <= this._configService.ISthreshold;
          this.seriesDataForTop10.push({
            name: item['Category Name'],
            type: 'scatter',
            zIndex: 1,
            marker: {
              symbol: this.properties.markerStyle,
              // fillColor: 'red',
              // lineColor: 'red',
              // lineWidth: 2,
              //fillColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i]) : this.properties.gradientBarColor ? this.barService.linearGradients[i] : this.barService.color1[i],
              fillColor: isLowSampleMarkerTop10
                ? 'rgba(0,0,0,0)'
                : this.properties.showPattern
                  ? this.getPatternForImage(this.barService.patternImages[i++])
                  : this.properties.gradientBarColor
                    ? item['colorLinearGradient']
                    : item['color'],
              lineColor: isLowSampleMarkerTop10
                ? 'rgba(0,0,0,0)'
                : this.properties.showPattern
                  ? this.getPatternForImage(this.barService.patternImages[i++])
                  : this.properties.gradientBarColor
                    ? item['colorLinearGradient']
                    : item['color'],
              // lineColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
              radius: 9,
              lineWidth: 0,
            },
            enableMouseTracking: false,
            showInLegend: false,
            visible: true,
            data: [
              {
                name: item['Category Name'],
                y: !lowSample1
                  ? item['Rounded Value'] == null ||
                    parseFloat(item['Rounded Value']) === 0
                    ? null
                    : parseFloat(item['Rounded Value']) > 0
                      ? parseFloat(item['Rounded Value'])
                      : parseFloat(item['Rounded Value']) +
                        0.04 * parseFloat(item['Rounded Value'])
                  : parseFloat(item['Sample size']) >
                        this.barService.sampleSizeConstant &&
                      item['Rounded Value'] != null &&
                      parseFloat(item['Rounded Value']) !== 0
                    ? parseFloat(item['Rounded Value']) > 0
                      ? parseFloat(item['Rounded Value'])
                      : parseFloat(item['Rounded Value']) +
                        0.05 * parseFloat(item['Rounded Value'])
                    : null,
                x: index + 1,
                z:
                  parseFloat(item['Sample Size']) >
                  this.barService.sampleSizeConstant
                    ? 0
                    : item['Rounded Value'] != null
                      ? parseFloat(item['Rounded Value'])
                      : 0,
                Sig_LowerLimt: this.Sig_LowerLimt,
                Sig_UpperLimt: this.Sig_UpperLimt,
                Significance_Value: item['Significance_Value'],
              },
            ],
          });
        }
      });
    } else {
      let value = 0;
      let maxValue = 0;
      let minValue = 0;
      //use full dataset (do not filter to a single series)
      const indiaData = chartData[0].data;
      this.chartCategories = Array.from(
        new Set(
          indiaData.map(
            (item: { [x: string]: string }) => item['Category Name'],
          ),
        ),
      );
      maxValue = Math.max(
        ...indiaData.map(
          (item: { [x: string]: string }) => parseFloat(item['Value']) || 0,
        ),
      );
      minValue = Math.min(
        ...indiaData.map(
          (item: { [x: string]: string }) => parseFloat(item['Value']) || 0,
        ),
      );
      this.max = maxValue + Math.ceil(maxValue * 0.4);
      this.min = minValue - Math.ceil(maxValue * 0.3);
      let i = 0;
      this.seriesData1 = indiaData.map(
        (item: { [x: string]: string }, index: number) => ({
          value:
            item['Value'] == null
              ? 0
              : Number(parseFloat(item['Value']).toFixed(2)),
          numericValue: !lowSample1
            ? value
            : parseFloat(item['Sample size']) >
                this.LollipopService.sampleSizeConstant
              ? value
              : 0,
          name: item['Category Name'],
          seriesName: item['Series Name'],
          color: this.barService.colors[i++ % this.barService.colors.length],
          visible: true,
          zIndex: 1,
          type: 'column',
          dataLabels: {
            borderWidth: 0,
          },
          tooltip: [],
          borderWidth: 0,
          pointWidth: 3,
          changeValueSeries: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['ChangeVs']),
          ),
          significance: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Significance']),
          ),
          significance2: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Significance2']),
          ),
          sampleSize: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Sample size']),
          ),
          roundedValue: indiaData.map((item: { [x: string]: string }) =>
            parseFloat(item['Value']),
          ),
          data: [
            {
              name: item['Series Name'],
              y: !lowSample1
                ? item['Value'] == null
                  ? 0
                  : Number(
                      parseFloat(item['Value']).toFixed(
                        Number(this.properties.decimalRoundOff),
                      ),
                    )
                : parseFloat(item['Sample size']) >
                    this.LollipopService.sampleSizeConstant
                  ? item['Value'] == null
                    ? 0
                    : Number(
                        parseFloat(item['Value']).toFixed(
                          Number(this.properties.decimalRoundOff),
                        ),
                      )
                  : 0,
              x: index,
            },
          ],
        }),
      );

      this.categoryImages = indiaData.map(
        (item: any) => item['Category Image'],
      );

      // Scatter series (Marker1) - Limit to 1 data point

      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        const isLowSampleMarkerBasic =
          this._configService.userRole != 'superadmin' &&
          Number(item['Sample size']) <= this._configService.ISthreshold;
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 2,
          marker: {
            symbol: this.properties.markerStyle,
            fillColor: isLowSampleMarkerBasic
              ? 'rgba(0,0,0,0)'
              : this.barService.colors[i % this.barService.colors.length],
            lineColor: isLowSampleMarkerBasic
              ? 'rgba(0,0,0,0)'
              : this.barService.colors[i % this.barService.colors.length],
            radius: 9,
            lineWidth: 0,
          },
          showInLegend: false,
          tooltip: {
            enabled: false, // Disable tooltip for this series
          },
          enableMouseTracking: false,
          visible: true,
          data: [
            {
              name: item['Category Name'],
              y: !lowSample1
                ? item['Value'] == null
                  ? null
                  : parseFloat(item['Value']) == 0
                    ? null
                    : Number(
                        parseFloat(item['Value']).toFixed(
                          this.properties.decimalRoundOff,
                        ),
                      )
                : parseFloat(item['Sample size']) >
                    this.LollipopService.sampleSizeConstant
                  ? item['Value'] == null
                    ? null
                    : parseFloat(item['Value']) == 0
                      ? null
                      : Number(
                          parseFloat(item['Value']).toFixed(
                            this.properties.decimalRoundOff,
                          ),
                        )
                  : null,
              x: index,
              z: Number(parseInt(item['Value'])),
              color: this.barService.colors[i % this.barService.colors.length], // Assign color based on index
            },
          ],
        });
        i++;
      });
    }
  }

  customization(): Observable<any> {
    const snapshotTypeSelectedName =
      this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType =
      snapshotTypeSelectedName &&
      snapshotTypeSelectedName.toLowerCase().includes('audience')
        ? this._configService.audienceCohortType
        : 'NA';

    return this._customSnapshotService.getChartCustomization(
      'Vertical Lollipop  Chart',
      this._customSnapshotService.selectedSnapshotType?.name,
      cohortType,
    );
  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LollipopService.applycustomization(event, item, this.properties);

    if (this.isOutput && this.customData) {
      this.preparemainChartData(
        this.customData,
        this.selectedMetric || this.LollipopService.selectedMetric,
      );
    }

    this.getData(this.jsonData, this.properties.datalabelStyle == 'lowSample');
    this.getChart(
      'chart-container' + this.id,
      this.seriesData1,
      this.seriesDataForTop10,
      this.properties,
    );
  }

  getChart(
    containerId: string,
    seriesData: any[],
    seriesDataTop10: any[],
    properties: any,
  ) {
    if (this.isOutput) {
      if (!seriesData || seriesData.length === 0) {
        const containerEl = document.getElementById(containerId);
        if (containerEl) {
          containerEl.innerHTML =
            '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      let popUp = this.popUp;
      localStorage.setItem('properties', JSON.stringify(this.properties));
      let serviceBar = this.barService;
      let i = 0;
      const updatedCategories1 = this.categoryImages;
      const defaultCategories = this.categories;

      const screenHeight = window.innerHeight; // Get the screen width
      let xAxisyLabelPosition;

      let height = '48%';
      if (screenHeight <= 610) {
        //for 150% -> 593
        // xAxisyLabelPosition = this.popUp ? 50 : 30;
        xAxisyLabelPosition = this.popUp ? 50 : 50;
      } else if (screenHeight <= 800) {
        //for 125% -> 738

        // xAxisyLabelPosition = this.popUp ? 40 : 5;
        xAxisyLabelPosition = this.popUp ? 40 : 5;
      } else if (screenHeight <= 1200) {
        //for 100%
        xAxisyLabelPosition = this.popUp ? 95 : 15;
        height = '40%';
      }

      const configService = this._configService;
      this.properties =
        this.configuredProperties != undefined
          ? this.configuredProperties
          : this.properties;
      this.properties.showLegend = false;
      properties = this.properties;
      let maxLabelCharacters = popUp ? 13 : 10;
      const maxTotalCharacters = 20;
      const options: Highcharts.Options = {
        chart: {
          type: 'column',
          reflow: true,
          // height: height,
          //marginBottom: defaultCategories.length > (this.maxDataPoints + 1) ? 40 : 0,

          //apply background color and text color based on light or dark theme
          backgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
            // height: this.height != '22em' ? 262 : 450,
            // height:'95%',
            fontSize: '0.7rem',
            overflow: 'visible',
            zIndex: 2,
          },
          events: {
            //to hide the marker along with the bar,when legend is click for each bar
            redraw: function (this: any) {
              // Adjust scatter series position after redrawing the chart
              var chart = this,
                series = chart.series;

              series.forEach(function (ser: any) {
                if (ser.type === 'column' && ser.type == 'scatter') {
                  ser[1].forEach(function (scatter: any) {
                    scatter.setVisible(ser.visible, false);
                  });
                }
              });
            },
            load: function () {
              const chart = this;
              // window.addEventListener('resize', function () {
              //chart.reflow();
              //});
              //#region wheel scroll
              const container = chart.container;
              const xAxis = chart.xAxis[0];

              function onWheel(e: any) {
                e = e || window.event;
                e.preventDefault();

                // Normalize wheel delta
                let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

                const extremes = xAxis.getExtremes();
                const step = 1; // how many categories to scroll at a time

                let newMin = extremes.min + delta * step;
                let newMax = extremes.max + delta * step;

                // Bound checks
                if (newMin < extremes.dataMin) {
                  newMin = extremes.dataMin;
                  newMax = newMin + (extremes.max - extremes.min);
                }
                if (newMax > extremes.dataMax) {
                  newMax = extremes.dataMax;
                  newMin = newMax - (extremes.max - extremes.min);
                }

                xAxis.setExtremes(newMin, newMax, true, false);
              }

              container.addEventListener('wheel', onWheel, {
                passive: false,
              });
              //#endregion
            },
          },
        },
        title: {
          //add title styles :position and color options
          // text: this.data.title,
          text: '',
          align: this.properties.chartTitlePosition,
          style: {
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
            marginleft: '4%',
            fontSize: '1em',
            fontFamily: this.barService.textfont,
          },
        },
        subtitle: {},
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        //legend position
        //legend: this.barService.customizeLegend(this.chart, false, this.properties.legendPosition, this.properties,this.height,popUp), // Semicolon added
        xAxis: {
          lineColor: '#A2A2A2', // Change to desired axis line color
          lineWidth: 1,
          categories: defaultCategories,
          gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,
          //shows 10 bars in each slide
          min: 1,
          max:
            this.seriesData1.length / 2 <= 8 ? this.seriesData1.length / 2 : 8,
          //if number of bars are greater than 10,scrollbar is seen
          //scrollbar styles
          scrollbar: {
            enabled:
              defaultCategories.length > this.maxDataPoints + 1 ? true : false,
            height: 5, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#7f7f7f',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.properties.darkTheme
              ? this.barService.darkThemeBackgroundColor
              : this.barService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.properties.darkTheme
              ? this.barService.darkThemeBackgroundColor
              : this.barService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme
              ? this.barService.darkThemeBackgroundColor
              : this.barService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme
              ? this.barService.darkThemeBackgroundColor
              : this.barService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5,
            margin: 20,
          },
          showEmpty: false,
          labels: {
            //x-axis labels styles
            useHTML: true,
            // y: xAxisyLabelPosition,
            style: {
              fontFamily: this.barService.textfont,
              color: this.properties.darkTheme
                ? this.barService.darkThemeTextColor
                : this.barService.defaultThemeTextColor,
            },
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject,
            ) {
              // Calculate available width per label
              const chart = this.axis.chart;
              const categories = this.axis.categories || [];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length - 1, 1); // Exclude first empty category

              // Calculate base width per category with enhanced popup support
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = popUp ? 15 : 8; // Reduced padding for popup to utilize more space
              const minWidth = popUp ? 120 : 80; // Higher minimum width for popups
              const labelWidth = Math.max(baseWidth - padding, minWidth);

              // Split label into max 2 lines, not breaking words
              function splitLabelToTwoLines(str: string, maxWidth: number) {
                // Estimate average character width (in px) - adjusted for better accuracy
                const avgCharWidth = popUp ? 6.0 : 6.5; // Slightly smaller char width for popup to fit more text
                const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);

                const words = str.split(' ');
                let line1 = '';
                let line2 = '';
                let currentLine = '';
                let breakIndex = 0;

                // Build first line
                for (let i = 0; i < words.length; i++) {
                  const testLine = currentLine
                    ? currentLine + ' ' + words[i]
                    : words[i];
                  if (testLine.length <= maxCharsPerLine || !currentLine) {
                    currentLine = testLine;
                    breakIndex = i + 1;
                  } else {
                    break;
                  }
                }
                line1 = currentLine;

                // Build second line with remaining words
                const remainingWords = words.slice(breakIndex);
                line2 = remainingWords.join(' ');

                // Truncate second line with ellipsis if needed
                if (line2.length > maxCharsPerLine) {
                  line2 =
                    line2.substring(0, maxCharsPerLine - 3).trim() + '...';
                }

                return line2 ? `${line1}<br/>${line2}` : line1;
              }

              let labelContent = String(this.value);
              labelContent = splitLabelToTwoLines(labelContent, labelWidth);

              // Determine text alignment based on number of lines
              const isMultiLine = labelContent.includes('<br/>');
              const textAlign = 'center';

              // If axisImage is enabled, show image instead
              if (properties.axisImage) {
                let index = categories.indexOf(String(this.value));
                const category1 =
                  serviceBar.baseImgPath + updatedCategories1[index] + '.png';
                if (category1) {
                  return `<span style="display: inline-block; width: 2em; height: 2em; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                // Center-align text for single line, left-align for multiple lines
                const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
                return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0;" title="${String(this.value)}">${labelContent}</div>`;
              }
            },
            rotation: this.barService.axisLabelOrientation(
              this.properties.axisLabelOrientation,
            ),
          },
        },
        yAxis: {
          //min and max for y-axis
          max:
                  this.maxBarValue > 0
            ? this.maxBarValue +
              Math.ceil(
                this.maxBarValue *
                  (this.properties.datalabelStyle === 'sigChange' ||
                  this.properties.datalabelStyle === 'significance' ||
                  this.properties.datalabelStyle === 'significance + changeVs' ||
                  this.properties.datalabelStyle === 'significance2'
                    ? 0.2
                    : 0.1),
              )
            : null,
          min:
            Number(
              Number(this.maxBarValue).toFixed(this.properties.decimalRoundOff),
            ) > 0
              ? 0
              : this.min,
          plotLines: [
            {
              value: 0,
              width: 1,
            },
          ],
          tickInterval:
            Number(
              Number(this.maxBarValue).toFixed(this.properties.decimalRoundOff),
            ) > 0
              ? this.getTickInterval(this.maxBarValue)
              : 0,
          //gridlines visibility
          gridLineWidth: this.properties.yaxisgridlines ? 1 : 0,

          //y-axis labels styles
          labels: {
            enabled: false,
            format:
              this.properties.datalabelFormat == 'percentage'
                ? '{value}%'
                : '{value}',
            style: {
              color: this.properties.darkTheme
                ? this.barService.darkThemeTextColor
                : this.barService.defaultThemeTextColor,
              fontFamily: this.barService.textfont,
            },
          },
          title: {
            text: '', // Set an empty string to hide the yAxis title
          },
        },
        //tooltip styles
        tooltip: {
          enabled: true,
          borderWidth: 1,
          useHTML: true,

          shadow: false,

          formatter: function (this: any) {
            //disable tootltip for marker
            if (this.series.name === 'Marker1') return false;
            //select tooltip style
            let isDefaultTooltip = properties.toolTipStyle;
            //tooltip border color
            const dotColor = this.color; // Get the series color
            const backgroundcolor = properties.darkTheme
              ? '#f5f5f5'
              : '#b3b3b3';
            const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
            //get the appropriate tooltip according to datalabel property selected
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x - 1]
              : this.y;
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
                `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;

              return commonContent + '</div>';
            } else {
              const content = `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 1.1em; display: flex; align-items: center; ">
      <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.point.name}: </span>
      <b style="margin-left:4px;">${text}</b>
    </div>`;
              return content;
            }
          },
        },
        // legend : {
        //   enabled : false,
        // },
        plotOptions: {
          series: {
            borderWidth: 0,
            animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false,
              },
              inactive: {
                enabled: false,
              },
              select: {
                enabled: false,
              },
            },

            //animation is set to off for datalabeposition* as it is applicable only for aspose side
            // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
            events: {
              //when a legend is clicked fro the bar,bar must disappear
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].type == 'scatter') {
                      series[i].scatterSeries.setVisible(
                        !series[i].visible,
                        false,
                      );
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              },
            },
          },

          column: {
            //plotting styles

            //distance between bars
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            //shadow styles
            shadow: this.properties.shadow
              ? {
                  color: this.barService.shadowColor,
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 6,
                }
              : false,
            //bar size
            pointWidth: 3,
            //datalabel styles
            dataLabels: {
              style: {
                backgroundColor: this.barService.transparentBackground,
                //datalabel border
                textOutline: 'none',
                //datalabel color
                color: this.properties.darkTheme
                  ? this.properties.dataLabelColor === 'default'
                    ? 'white'
                    : this.properties.dataLabelColor ||
                      this.barService.darkThemeTextColor
                  : this.properties.dataLabelColor === 'default'
                    ? 'black'
                    : this.properties.dataLabelColor ||
                      this.barService.defaultThemeTextColor,
                //datalabel font size
                fontSize: this.properties.dataLabelSize,
                fontWeight: 'normal',
                fontFamily: this.barService.textfont,
              },

              //overflow: 'allow',
              overflow: 'justify',
              crop: false,
              //enable the datalabel based on selection
              enabled: this.properties.showDataLabel,
              //datalabel is shown inside the bar
              inside: false,

              //datalabel alignment
              align: this.properties.dataLabelPosition,
              //datalabel overlap is set to true by default
              allowOverlap: true,
              //datalabel position
              verticalAlign: this.properties.dataLabelPosition,
              y: properties.datalabelStyle == 'default' ? -30 : -40, // this.properties.dataLabel_y_positionVertical,
              x:
                properties.datalabelStyle == 'index'
                  ? this.properties.dataLabel_x_position - 10
                  : this.properties.dataLabel_x_position,

              formatter: function (this: any) {
                let barHeight = this.y;
                // Calculate the dynamic Y position based on the value of the bar
                let dynamicY = barHeight + barHeight * 0.2;
                if (properties.datalabelStyle == 'index') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y + (this.series.data[0].ispercent ? '%' : '')
                      : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(
                    configService.userRole,
                    text,
                    this.series.userOptions.sampleSize[this.point.x - 1],
                  );

                  this.series.userOptions.tooltip[this.point.x - 1] = text;

                  // let text2 = this.series.userOptions.roundedValue[this.point.x - 1] === 0
                  //   ? serviceBar.nullValueText
                  //   : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : serviceBar.nullValueText;

                  let text2 =
                    this.point.actualIndexValue == null
                      ? serviceBar.nullValueText
                      : this.series.userOptions.roundedValue[
                            this.point.x - 1
                          ] == -1
                        ? -1
                        : this.series.userOptions.roundedValue[
                              this.point.x - 1
                            ] != null
                          ? this.point.indexValue
                          : serviceBar.nullValueText;

                  if (text2 == '-1' || text2 == -1) {
                    text2 = 'NA';
                  }
                  text2 = configService.CheckLSorIScondition(
                    configService.userRole,
                    text2,
                    this.series.userOptions.sampleSize[this.point.x - 1],
                  );

                  let color = configService.CheckIndexColoring(text2);

                  this.series.userOptions.tooltip[this.point.x - 1] =
                    text + '(' + text2 + ')';
                  return (
                    '<span style="font-size:0.5rem;">' +
                    text +
                    '</span><br>' +
                    ' ' +
                    '(' +
                    '<span style="color:' +
                    color +
                    ';font-size:0.5rem;">' +
                    text2 +
                    '</span>' +
                    ')'
                  );
                }

                if (properties.datalabelStyle == 'sigChange') {
                  //extract each changeVs value
                  let changeText = this.series.userOptions.isPercentage
                    ? this.series.userOptions.changeValueSeries[
                        this.point.x - 1
                      ] * 100
                    : this.series.userOptions.changeValueSeries[
                        this.point.x - 1
                        ];
                      changeText = roundChangeText(changeText);
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let textCheck = configService.CheckLSorIScondition(
                    configService.userRole,
                    this.y,
                    this.series.userOptions.sampleSize[this.point.x - 1],
                  );
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? textCheck +
                        (this.series.userOptions.isPercentage &&
                        textCheck != 'I/S'
                          ? '%'
                          : '')
                      : serviceBar.nullValueText;
                  // text = textCheck+ (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '');
                  //extarct each signififcance value
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  //set the significance arrow according to its value
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                        ? serviceBar.downwardTriangle
                        : '';
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  //include + if changeValue is positive
                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  let sigClass =
                    this.series.userOptions.Significance_Value <
                    this.series.userOptions.Sig_LowerLimt
                      ? 'red'
                      : this.series.userOptions.Significance_Value >
                          this.series.userOptions.Sig_UpperLimt
                        ? 'green'
                        : 'black';
                  //merge text+changeText+significance
                  if (
                    this.series.userOptions.changeValueSeries[
                      this.point.x - 1
                    ] == null ||
                    this.series.userOptions.changeValueSeries[
                      this.point.x - 1
                    ] == 'NA'
                  ) {
                    let finalText =
                      '<span>' +
                      '<span>' +
                      text +
                      '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] !=
                        null && textCheck != 'I/S'
                        ? '<span>&nbsp<br>' +
                          '<span style="color:' +
                          sigClass +
                          '; font-size: 70%;  ">(NA)</span>&nbsp;' +
                          '</span>'
                        : '') +
                      '</span>';

                    let tooltipText =
                      '<span>' +
                      '<span>' +
                      text +
                      '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] !=
                        null && textCheck != 'I/S'
                        ? '<span>&nbsp' +
                          '<span style="color:' +
                          sigClass +
                          '; font-size: 70%;  ">(NA)</span>&nbsp;' +
                          '</span>'
                        : '') +
                      '</span>';
                    //assign the finalText to tooltip
                    this.series.userOptions.tooltip[this.point.x - 1] =
                      tooltipText;
                    //return the finalText
                    return finalText;
                  } else {
                    let finalText =
                      '<span>' +
                      '<span>' +
                      text +
                      '</span>' +
                      (this.series.userOptions.Significance_Value == 0
                        ? '<br><span style="color:' +
                          sigClass +
                          '; font-size: 70%;  ">(' +
                          (this.series.userOptions.Significance_Value +
                            (this.series.userOptions.isPercentage ? '%' : '')) +
                          ')</span>&nbsp;' +
                          '</span>'
                        : this.series.userOptions.roundedValue[
                              this.point.x - 1
                            ] != null &&
                            changeText != null &&
                            textCheck != 'I/S'
                          ? '<span>&nbsp<br>' +
                            '<span style="color:' +
                            sigClass +
                            '; font-size: 70%;  ">(' +
                            (Math.round(Number(changeText)) +
                              (this.series.userOptions.isPercentage
                                ? '%'
                                : '')) +
                            ')</span>&nbsp;' +
                            '</span>'
                          : '') +
                      '</span>';

                    let tooltipText =
                      '<span>' +
                      '<span>' +
                      text +
                      '</span>' +
                      (this.series.userOptions.Significance_Value == 0
                        ? '<br><span style="color:' +
                          sigClass +
                          '; font-size: 70%;  ">(' +
                          (this.series.userOptions.Significance_Value +
                            (this.series.userOptions.isPercentage ? '%' : '')) +
                          ')</span>&nbsp;' +
                          '</span>'
                        : this.series.userOptions.roundedValue[
                              this.point.x - 1
                            ] != null &&
                            changeText != null &&
                            textCheck != 'I/S'
                          ? '<span>&nbsp' +
                            '<span style="color:' +
                            sigClass +
                            '; font-size: 70%;  ">(' +
                            (Math.round(Number(changeText)) +
                              (this.series.userOptions.isPercentage
                                ? '%'
                                : '')) +
                            ')</span>&nbsp;' +
                            '</span>'
                          : '') +
                      '</span>';
                    //assign the finalText to tooltip
                    this.series.userOptions.tooltip[this.point.x - 1] =
                      tooltipText;
                    //return the finalText
                    return finalText;
                  }
                }

                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == 'significance + changeVs') {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  //extarct each signififcance value
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  //set the significance arrow according to its value
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                        ? serviceBar.downwardTriangle
                        : '';
                  //assign color to the arrow
                  let sigcolor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                        ? serviceBar.lowSignificance
                        : '';
                  //include + if changeValue is positive
                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '<span>&nbsp' +
                        '<span style="font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        '; ">(' +
                        changeText +
                        ')</span>&nbsp;' +
                        '<span style="color:' +
                        sigcolor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  //return the finalText
                  return finalText;
                }
                if (properties.datalabelStyle == 'change') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  let finalText =
                    '<span>' +
                    text +
                    '  ' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '<span>&nbsp' +
                        '<span style="font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        '; ">(' +
                        changeText +
                        ')</span>&nbsp;' +
                        '</span>'
                      : '');
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }

                if (properties.datalabelStyle == 'ls') {
                  let text =
                    parseFloat(
                      this.series.userOptions.sampleSize[this.point.x - 1],
                    ) > serviceBar.sampleSizeConstant
                      ? this.series.userOptions.roundedValue[
                          this.point.x - 1
                        ] != null
                        ? this.y +
                          (properties.datalabelFormat == 'percentage'
                            ? '%'
                            : '')
                        : serviceBar.nullValueText
                      : serviceBar.lowSampleText;
                  let finalText =
                    '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }
                if (properties.datalabelStyle == 'significance') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                        ? serviceBar.downwardTriangle
                        : '';
                  let sigcolor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                        ? serviceBar.lowSignificance
                        : '';
                  let finalText =
                    '<span >' +
                    text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? '&nbsp<span style="color:' +
                        sigcolor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return finalText;
                }
                if (properties.datalabelStyle == 'default') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y + (this.series.data[0].ispercent ? '%' : '')
                      : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(
                    configService.userRole,
                    text,
                    this.series.userOptions.sampleSize[this.point.x - 1],
                  );

                  this.series.userOptions.tooltip[this.point.x - 1] = text;

                  return '<span >' + text + '</span>';
                }
                if (properties.datalabelStyle == 'datalabel') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return '<span >' + text + '</span>';
                }

                if (properties.datalabelStyle == 'significance2') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  let sig1 =
                    this.series.userOptions.significance2[this.point.x - 1];
                  let sColor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                        ? serviceBar.lowSignificance
                        : '';
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                        ? serviceBar.downwardTriangle
                        : '';
                  let changeColor =
                    sig1 < 0
                      ? serviceBar.lowSignificance
                      : sig1 > 0
                        ? serviceBar.highSignificance
                        : properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor;

                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  let finalText =
                    '<span>' +
                    text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '&nbsp<span style="color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        ' "> ' +
                        '<span style="font-size:' +
                        serviceBar.changeValueFontSize +
                        '; color:' +
                        changeColor +
                        ';">(' +
                        changeText +
                        ')</span>&nbsp' +
                        '<span style="color:' +
                        sColor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return finalText;
                }

                return !Number.isNaN(
                  this.series.userOptions.roundedValue[this.point.x - 1],
                )
                  ? this.y
                  : 'NA';
              },
            },
          },
        },
        series: properties.top10 ? seriesDataTop10 : seriesData,
      };
      const containerEl = document.getElementById('chart-container' + this.id);
      if (!containerEl) {
        return;
      }
      Highcharts.chart(containerEl, options);
    } else {
      localStorage.setItem('properties', JSON.stringify(this.properties));
      const numberOfTicks = 5; // Adjust this value according to your preference
      const maxCategoriesToShow = 7;
      const tickInterval = Math.ceil(this.max / numberOfTicks);
      let sampleSizeConstant = this.LollipopService.sampleSizeConstant;
      const serviceBar = this.LollipopService;
      const categoryImages = this.categoryImages;

      const defaultCategories = this.chartCategories;
      let plotBandsConfig: { color: string; from: number; to: number }[] = [];
      const numPlotBands = defaultCategories.length;

      if (this.properties.plotBands) {
        for (let i = 0; i < numPlotBands; i += 2) {
          const from = i + 0.5;
          const to = from + 1;
          plotBandsConfig.push({
            color: this.properties.darkTheme
              ? this.LollipopService.plotBandsdark
              : this.LollipopService.plotBandsColor,
            from,
            to,
          });
        }
      }

      const containerEl = document.getElementById(containerId);
      if (!containerEl) {
        return;
      }
      this.chart = Highcharts.chart(containerEl, {
        chart: {
          type: 'column',
          backgroundColor: this.properties.darkTheme
            ? this.LollipopService.darkThemeBackgroundColor
            : this.LollipopService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.LollipopService.textfont,
            color: this.properties.darkTheme
              ? this.LollipopService.darkThemeTextColor
              : this.LollipopService.defaultThemeTextColor,
          },
        },
        title: {
          text: '',
          align: this.properties.chartTitlePosition,
          fontFamily: this.LollipopService.textfont,
          style: {
            color: this.properties.darkTheme
              ? this.LollipopService.darkThemeTextColor
              : this.LollipopService.defaultThemeTextColor,
          },
        },
        subtitle: {},
        //legend: this.LollipopService.customizeLegend(this.properties.showLegend, this.properties.legendPosition, this.properties),
        legend: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },

        xAxis: {
          visible: true,
          categories: this.chartCategories,
          plotBands: plotBandsConfig,
          min: 0,
          max: maxCategoriesToShow,
          showEmpty: false,
          labels: {
            useHTML: true,
            style: {
              color: this.properties.darkTheme
                ? this.LollipopService.darkThemeTextColor
                : this.LollipopService.defaultThemeTextColor,
              fontSize: '0.7rem',
            },
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject,
            ) {
              if (properties.axisImage) {
                var index = defaultCategories.indexOf(String(this.value));
                var category1 =
                  serviceBar.baseImgPath + categoryImages[index] + '.png';
                if (category1) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(' +
                    category1 +
                    ') no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                // return String(this.value);
                return `<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 0% 4%;" title="${String(this.value)}">${String(this.value)}</div>`;
              }
            },
            rotation: this.LollipopService.xAxisLabelOrientation(
              this.properties.axisLabelOrientation,
              this.properties,
            ), // Rotate labels by -90 degrees (or any other desired angle)
          },
          scrollbar: {
            enabled:
              this.chartCategories.length - 1 > maxCategoriesToShow
                ? true
                : false,
            height: 6, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#7f7f7f', //#0060FF,
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.properties.darkTheme
              ? this.LollipopService.darkThemeBackgroundColor
              : this.LollipopService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.properties.darkTheme
              ? this.LollipopService.darkThemeBackgroundColor
              : this.LollipopService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme
              ? this.LollipopService.darkThemeBackgroundColor
              : this.LollipopService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme
              ? this.LollipopService.darkThemeBackgroundColor
              : this.LollipopService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5,
          },
        },

        yAxis: {
          title: '',
          max: this.max,
          min: this.min,
          plotLines: [
            {
              value: 0,
              width: 1,
            },
          ],
          gridLineWidth: this.properties.gridlines ? 1 : 0,
          labels: {
            enabled: false,
            rotation: this.LollipopService.xAxisLabelOrientation(
              this.properties.yaxisLabelOrientation,
              this.properties,
            ), // Rotate labels by -90 degrees (or any other desired angle)
            format:
              this.properties.datalabelFormat == 'number'
                ? '{value}'
                : '{value}%',
            style: {
              color: this.properties.darkTheme
                ? this.LollipopService.darkThemeTextColor
                : this.LollipopService.defaultThemeTextColor,
            },
          },
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function (this: any) {
            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const dotColor = this.series.color; // Get the series color
            const backgroundcolor = properties.darkTheme
              ? '#b3b3b3'
              : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            let text =
              properties.showDataLabel == true
                ? this.series.userOptions.tooltip[this.point.x]
                : this.y;
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                // `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.key}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;
              return commonContent + '</div>';
            } else {
              // const content =
              //   `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              //   `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"></div>` +
              //   ` ${this.series.name}` +
              //   `<div style="display: block; margin-top: 5%;"><strong>Value:</strong> ${text}</div>`;
              // return content + '</div>';

              const commonContent =
                `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};width:fit-content; z-index: 100; padding: 2%; border-radius: 5px;font-size: 1.2em; margin: 0; background-color :${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                //`<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
                `${this.series.name} : ` +
                `${text}`;

              return commonContent + '</div>';
            }
          },
        },

        plotOptions: {
          series: {
            animation: false,
            events: {
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].scatterSeries) {
                      series[i].scatterSeries.setVisible(
                        !series[i].visible,
                        false,
                      );
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              },
            },
          },
          column: {
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            pointWidth: 3,
            allowOverlap: this.properties.allowOverlap,
            useHTML: true,
            dataLabels: {
              padding: 10, //adjust the padding accordingly or remove it based on requirement
              style: {
                backgroundColor: this.LollipopService.transparentBackground,
                textOutline: 'none',
                color: this.properties.darkTheme
                  ? this.properties.dataLabelColor === 'default'
                    ? this.LollipopService.darkThemeTextColor
                    : this.properties.dataLabelColor ||
                      this.LollipopService.darkThemeTextColor
                  : this.properties.dataLabelColor === 'default'
                    ? 'black'
                    : this.properties.dataLabelColor ||
                      this.LollipopService.defaultThemeTextColor,
                fontSize: this.properties.dataLabelSize,
                fontWeight: 'normal',
              },
              enabled: this.properties.showDataLabel,
              crop: false,
              overflow: 'allow',
              rotation: this.properties.datalabelOrientation,
              align:
                this.properties.dataLabelPosition === 'right'
                  ? 'left'
                  : this.properties.dataLabelPosition === 'left'
                    ? 'right'
                    : 'center', // Set alignment based on the value of this.properties.dataLabelPosition,
              //if left is the value then it is aligned to right and vice-versa
              formatter: function (this: any) {
                let sigcolor;
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                const upColor = 'green';
                const downColor = 'red';
                let changeText;
                let text;
                let sig;
                let sColor;
                let finalText;

                if (
                  this.series.userOptions.roundedValue[this.point.x] == null
                ) {
                  finalText = 'NA';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'significance + changeVs') {
                  text =
                    this.y +
                    (properties.datalabelFormat == 'percentage' ? '%' : '');
                  changeText =
                    this.series.userOptions.changeValueSeries[this.point.x];
                  sig = this.series.userOptions.significance[this.point.x];
                  sColor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let changeColor = properties.darkTheme ? 'white' : 'black';

                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }

                  finalText =
                    '<span>' +
                    text +
                    (changeText
                      ? '&nbsp<span style="color:' +
                        ';">' +
                        '<span style="font-size: 80%; color:' +
                        changeColor +
                        ';">(' +
                        changeText +
                        ')</span>&nbsp' +
                        '<span style="color:' +
                        sColor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'datalabel') {
                  text =
                    this.y +
                    (properties.datalabelFormat == 'percentage' ? '%' : '');
                  finalText = '<span >' + text + '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'change') {
                  text =
                    this.y +
                    (properties.datalabelFormat == 'percentage' ? '%' : '');
                  changeText =
                    this.series.userOptions.changeValueSeries[this.point.x];

                  let changeColor = properties.darkTheme ? 'white' : 'black';

                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }

                  finalText = `<div style="display: block; text-align: center;">
                    <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                     &nbsp<div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                     </div>`;
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'significance') {
                  text =
                    this.y +
                    (properties.datalabelFormat == 'percentage' ? '%' : '');
                  sig = this.series.userOptions.significance[this.point.x];
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  sigcolor = sig > 0 ? upColor : sig < 0 ? downColor : '';

                  finalText =
                    '<span >' +
                    text +
                    '&nbsp<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'significance2') {
                  text =
                    this.y +
                    (properties.datalabelFormat == 'percentage' ? '%' : '');
                  changeText =
                    this.series.userOptions.changeValueSeries[this.point.x];
                  sig = this.series.userOptions.significance[this.point.x];
                  let sig1 =
                    this.series.userOptions.significance2[this.point.x];
                  sColor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : properties.darkTheme
                          ? 'white'
                          : 'black';

                  changeText = roundChangeText(changeText);
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }

                  finalText =
                    '<span>' +
                    text +
                    (changeText
                      ? '&nbsp<span style="color:' +
                        ';">' +
                        '<span style="font-size: 80%; color:' +
                        changeColor +
                        ';">(' +
                        changeText +
                        ')</span>&nbsp' +
                        '<span style="color:' +
                        sColor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'ls') {
                  text =
                    parseFloat(
                      this.series.userOptions.sampleSize[this.point.x],
                    ) > sampleSizeConstant
                      ? this.y != null
                        ? this.y +
                          (properties.datalabelFormat == 'percentage'
                            ? '%'
                            : '')
                        : 'NA'
                      : 'LS';

                  finalText =
                    '<span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }
                finalText =
                  this.y +
                  (properties.datalabelFormat == 'percentage' ? '%' : '');
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              },
            },
          },
        },
        series: seriesData,
      } as any);
    }
  }

  getTickInterval(maxBarValue: number, precision: number = 0.05): number {
    if (maxBarValue <= 0) return 0.05;

    const desiredTickCount = 4;
    const rawInterval = maxBarValue / desiredTickCount;

    const step = 1 / precision;
    const rounded = Math.ceil(rawInterval * step) / step;

    return rounded + 0.01;
  }

  userselectedproperties() {
    this.data['properties'][0] = this.properties;
    return JSON.stringify(this.data).toString();
  }
  index = -1;
  transformRowChild(data: any[]): any[] {
    if (!data || data.length === 0) return data;

    // Check if all options are same
    const allOptionsSame =
      new Set(data.map((x) => x.option?.trim())).size === 1;

    return data.map((item) => {
      return {
        ...item,
        data: item.data.map((d: any) => {
          const parts =
            d.rowChild?.split('|').map((p: string) => p.trim()) || [];

          let updatedRowChild = '';

          if (parts.length === 0) return d;

          const last = parts[parts.length - 1]?.toLowerCase();

          // ✅ Rule 1: If last is Yes/No → take second last
          if (last === 'yes' || last === 'no') {
            updatedRowChild = parts[parts.length - 2] || '';
          } else if (allOptionsSame) {
            // ✅ Rule 2: all options same → last value
            updatedRowChild = parts[parts.length - 1] || '';
          } else {
            // ✅ Rule 3: different options → last two after first pipe
            if (parts.length >= 3) {
              updatedRowChild = `${parts[1]} | ${parts[2]}`;
            } else {
              updatedRowChild = parts.slice(1).join(' | ');
            }
          }

          return {
            ...d,
            rowChild: updatedRowChild,
          };
        }),
      };
    });
  }

  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
